import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import TemporaryDrawer from '../sidebar/sidebar';
import { Anchor } from '../sidebar/sidebar'
import AuthContext from '../../context/AuthContext';
import { Login as LoginIcon, Logout as LogoutIcon } from '@mui/icons-material';

interface AppAppBarProps {
  title: string,
}

export default function ButtonAppBar(
  {title} : AppAppBarProps
) {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const { user, logoutUser } = React.useContext(AuthContext);

  const location = window.location.pathname

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });
    };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <Button href="/">
            <img src="/logo192.png" alt={title} height="60" />
          </Button>          
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {title}
          </Typography>

          { user &&
            <>
              <Typography sx={{ display: { xs: 'none', sm: 'block' } }} >
                {user}
              </Typography>
              <IconButton color="inherit" onClick={logoutUser}>
                <LogoutIcon />
              </IconButton>
            </>
          }
          
          {
            !user && (location !== '/login') &&
            <IconButton
              size="large"
              color="inherit"
              aria-label="login"
              href='/login'
            >
              <LoginIcon />
            </IconButton>
          }

          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer("right", true)}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <TemporaryDrawer state={state} toggleDrawer={toggleDrawer}/>
    </Box>
  );
}
